<template>
  <div ref="utterance" class="msg-container relative">
    <div
      :class="['msg flex py-5', direction === 'right' ? 'owner' : '', bgColor ? 'colorful' : '']"
    >
      <div class="max-w-9/10">
        <template v-for="(msg, index) in htmlMessages">
          <div :key="`_${index}`" class="message-warpper">
            <!-- 头像 -->
            <div class="msg-profile flex-shrink-0 relative">
              <img
                v-if="isDebug"
                src="./assets/error.svg"
                alt=""
                class="w-10 h-10 rounded-full object-cover"
              />
              <img v-else :src="avatar" class="w-10 h-10 rounded-full object-cover" />
            </div>
            <div class="msg-text relative">
              <div
                class="content-name flex items-center"
                :class="direction === 'right' ? 'justify-end' : ''"
              >
                {{ content.name }}
                <img
                  v-if="isDebug"
                  v-tooltip.bottom="{
                    content: `<span>不存在的名称，请检查人物列表是否定义</span>`,
                    html: true
                  }"
                  style="width: 16px; height: 16px; margin-left: 2px;"
                  class="inline"
                  src="@/components/message/assets/warn.svg"
                />
              </div>
              <MessageIcon
                :color="bgColor ? bgColor.color : direction === 'right' ? '#6965f5' : undefined"
                class="message-icon"
              />
              <!-- <div
                  v-if="index === messages.length - 1"
                  class="px-4 py-3 message-bg min-h-48 rounded-md last-content content-wrapper"
                >
                  <loading class="mt-1" />
                </div> -->
              <div class="relative content-wrapper">
                <!-- markdown/common -->
                <div
                  v-select-menu="{
                    type: 'text',
                    index
                  }"
                  v-highlight
                  :class="[
                    'message message-bg prose prose-lg',
                    direction === 'right' ? 'prose-white' : '',
                    index === htmlMessages.length - 1 ? 'last-content' : '',
                    (/code/).test(msg) ? 'code-block' : '',
                    expandVisible && 'expand'
                  ]"
                  :style="bgColor ? `color: #FFF; background-color: ${bgColor.color};` : ''"
                  v-html="msg"
                ></div>
                <div :class="['note-svg', direction]">
                  <img
                    v-if="
                      content.noteIds && content.noteIds[index] && content.noteIds[index].length
                    "
                    src="./assets/note.png"
                    alt="笔记"
                    @click="handleOpenNote(index)"
                  />
                </div>
                <NoteShow
                  :ref="`NoteShow${index}`"
                  :content="content"
                  :isFocus="note.currentCheckId === content.$id && note.currentCheckIndex === index"
                  :utteranceIndex="index"
                  :environment="environment"
                  @clickNote="handlechangeFocus(index)"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import store from '@/store/index';
import Loading from '@/components/loading';
import showdown from 'showdown';
import Explanation from '../Explanation';
import { namespace } from 'vuex-class';

import { directive as SelectMenu } from '@/components/select-menu';
import NoteShow from '@/components/select-menu/note/Show.vue';
import { Note } from '@/store/modules/common/types';

import CopyCodeBtn from './components/CopyCodeBtn.vue';
import ExpandCodeBtn from './components/ExpandCodeBtn.vue';
import MessageIcon from './assets/MessageIcon.vue';

// import ketex from 'katex';

const throttleTime = 650;
const userModule = namespace('common');

const KATEX_SEPARATOR = '__';
const KATEX_PREFIX = 'katex';
const KATEX_PLACEHOLDERS = '^katex^';

// function isValidMarkdownCodeBlock(str: string) {

//   console.log('函数内', str)

//   const codeBlockRegex = /^```[\s\S]*?```$/;
//   return codeBlockRegex.test(str);
// }

const COLOR_BG = {
  主题蓝: {
    name: 'main-blue',
    color: '#6865ED'
  },
  天空蓝: {
    name: 'sky-blue',
    color: '#6CB2F1'
  },
  浅蓝色: {
    name: 'light-blue',
    color: '#88A1FA'
  },
  紫色: {
    name: 'purple',
    color: '#BC8CE8'
  },
  绿色: {
    name: 'green',
    color: '#76CBBB'
  }
};

@Component({
  components: {
    Loading,
    Explanation,
    NoteShow,
    MessageIcon
  },
  directives: {
    SelectMenu
  }
})
export default class Utterance extends Vue {
  @Prop({ type: Object }) content!: Content & {
    name: string;
    index?: number; // content 的索引，限制展示数据的数量
    messages: Array<string>;
    explanations: Array<{
      nouns: string;
      explanation: string;
    }>;
    noteIds?: Record<number, any[]>;
    touchLoading?: boolean;
    takingNotes?: boolean;
  };

  @Prop({ type: Array }) characters!: Array<{
    name: string;
    avatar: string;
    direction?: 'right' | 'left';
    color: keyof typeof COLOR_BG;
  }>;

  @Prop({ type: Boolean }) isroll!: boolean;
  @Prop({ type: Number }) utteranceInterval!: number;
  @userModule.State('note') note!: Note;

  tooltipVisible = false;
  timeoutId: number | undefined;

  throttle = true;
  updatedWorld = false;
  timer: number;

  expandVisible = false
  expandText = '查看全部'

  get index(): number {
    return this.content.index || 0;
  }

  // 获取content.messages下的0到索引index的数据
  get messages(): Array<string> {
    if (window.storyteller.topContet?.$id === this.content.$id) {
      this.throttleMessage();
    }
    return this.content.messages.slice(0, this.index + 1);
  }

  get htmlMessages(): Array<string> {
    const converter = new showdown.Converter({
      simpleLineBreaks: true,
      openLinksInNewWindow: true,
      tables: true,
      strikethrough: true
    });

    return this.messages.map((msg) => {
      let htmlStr = '';
      // 解析katex
      // const katexArr: Array<string> = []
      // const msgArr = msg.split(KATEX_SEPARATOR).map((item, index, array) => {
      //   const katexPrefixStr = item.trim()
      //   if (!katexPrefixStr.startsWith(KATEX_PREFIX)) {
      //     if(index === 0) return item
      //     if (!array[index -1].startsWith(KATEX_PREFIX)) return `__${item}`
      //     return item
      //   }
      //   katexArr.push(ketex.renderToString(katexPrefixStr.replace(KATEX_PREFIX, '')))
      //   return `${KATEX_PLACEHOLDERS}${katexArr.length - 1}`;
      // });

      // 解析markdown
      htmlStr = converter.makeHtml(this.formatExplanation(msg));
      // htmlStr = converter.makeHtml(this.formatExplanation(msgArr.join('')));

      // 插入katex解析内容
      // katexArr.forEach((item, index) => {
      //   htmlStr = htmlStr.replace(`${KATEX_PLACEHOLDERS}${index}`, item)
      // })

      return htmlStr;
    });
  }

  get environment() {
    return store.state.common.environment;
  }

  get isEdit() {
    return this.environment?.kind === 'edit';
  }

  get isDebug() {
    return this.isEdit && !this.avatar;
  }

  get hasLoading() {
    if (this.isEdit) {
      return false;
    }
    return this.throttle && this.updatedWorld;
  }

  get avatar() {
    const avatar = this.characters.filter((item) => item.name === this.content.name)[0]?.avatar;
    avatar && this.$emit('getCurrentAvatar', avatar);
    return avatar;
  }

  get bgColor() {
    const color = this.characters.filter((item) => item.name === this.content.name)[0]?.color || '';
    return COLOR_BG[color] || '';
  }

  // 方向: left 是默认，right 头像信息将在右侧出现
  get direction() {
    const direction = this.characters.filter((item) => item.name === this.content.name)[0]
      ?.direction;
    return direction;
  }

  @Watch('index')
  indexChange() {
    if (this.index === this.content.messages.length - 1 && this.utteranceInterval) {
      window.clearInterval(this.utteranceInterval);
      this.$emit('update:utteranceInterval', 0);
    }
    this.initCopyCode();
  }

  mounted() {
    this.initContent();
    this.initNouns();
    this.initCopyCode();
  }

  initContent() {
    if (this.content.index === undefined) {
      window.storyteller.updateContent((content) => ({
        index: 0
      }));
    }
  }

  initNouns() {
    this.$nextTick(() => {
      const target = this.$refs.utterance as Element;
      if (!target) return;
      const elements = target.querySelectorAll('.explanation_nouns');

      elements.forEach((element: Element) => {
        const index = Number(element.getAttribute('index') as string);
        const explanation = this.content.explanations[index];
        if (!explanation) return;
        const explanationElement = new Vue({
          render(h) {
            return h(Explanation, {
              props: {
                nouns: explanation.nouns,
                desc: explanation.explanation,
                direction: element.getAttribute('direction')
              }
            });
          }
        }).$mount();

        element.parentElement?.replaceChild(explanationElement.$el, element);
      });
    });
  }

  initCopyCode(isRetry?: boolean) {
    this.$nextTick(() => {
      const utteranceEl = this.$refs.utterance as HTMLDivElement;

      // 未获取尝试一次重试
      if (!utteranceEl) {
        if (isRetry) return;
        return this.initCopyCode(true);
      }

      const preEls = utteranceEl.querySelectorAll('pre');
      if (!preEls.length) return;
      preEls.forEach((preEl) => {
        const preWarpper = document.createElement('div');
        const clonePre = preEl.cloneNode(true);
        const preElParent = preEl.parentElement;
        preWarpper.appendChild(clonePre);
        preElParent?.replaceChild(preWarpper, preEl);

        preWarpper.setAttribute('style', 'position: relative;');

        // 主动loading600s 延后规避
        setTimeout(() => {
          const copyBtn = new CopyCodeBtn();
          const copyBtnEl = copyBtn.$mount();
          // eslint-disable-next-line max-nested-callbacks
          copyBtnEl.$on('copy', async () => {
            const codeEl = preWarpper.querySelector('code');
            if (!codeEl) return;
            await navigator.clipboard.writeText(codeEl.innerText);
            this.$Message.success({
              time: 1500,
              content: '复制成功'
            });
          });
          preWarpper.appendChild(copyBtnEl.$el);
        }, 700)

        if (preWarpper.getClientRects()?.[0]?.height > 420) {
          const expandBtn = new ExpandCodeBtn()
          const expandBtnEl = expandBtn.$mount();
          (clonePre as any).setAttribute('style', 'max-height: 30rem; overflow: hidden')
          expandBtnEl.$on('expand', () => {
            this.expandVisible = !this.expandVisible
            if (this.expandVisible) {
              preWarpper.removeChild(expandBtnEl.$el)
            }
          })
          preWarpper.appendChild(expandBtnEl.$el)
        }
      });
    });
  }

  throttleMessage() {
    this.throttle = true;
    // 传送门back时不需要loading
    if (!this.isroll) this.throttle = false;
    // 规避非更新index对话loading
    if (!this.content.touchLoading) this.throttle = false;
    clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      this.throttle = false;
      this.updatedWorld = true;
      this.$emit('loaded');
      this.initNouns();
    }, throttleTime);
  }

  beforeDestory() {
    clearTimeout(this.timer);
  }

  formatExplanation(msg: string) {
    if (!this.content.explanations) return msg;
    let newMsg = msg;
    this.content.explanations.forEach((explanation, index) => {
      newMsg = newMsg.replace(
        explanation.nouns,
        `<span class="explanation_nouns" index="${index}" direction="${this.direction}">${explanation.nouns}</span>`
      );
    });
    return newMsg;
  }

  handleOpenNote(index: number) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    const noteShow = this.$refs[`NoteShow${index}`] as Array<Vue & { open: Function }>;
    if (!noteShow?.length) return;
    noteShow[0].open();
    this.handlechangeFocus(index);
  }

  handlechangeFocus(index: number) {
    this.$store.commit('common/setCurrentNoteCheck', {
      currentCheckId: this.content.$id,
      currentCheckIndex: index
    });
  }
}
</script>

<style scoped>
.owner {
  @apply flex-row-reverse;
}

.owner .message-bg {
  @apply text-white;
  background-color: #6965f5;
}

.message-bg {
  @apply bg-base text-black overflow-hidden rounded-motif;
}

.message {
  @apply px-4 py-2 max-w-full;
  min-height: 44px;
  font-size: 17px;
}

.message-warpper {
  @apply flex mt-5;
}

.owner .message-warpper {
  @apply flex-row-reverse;
}

.content-wrapper {
  @apply flex;
}

.owner .content-wrapper {
  @apply justify-end;
}

.message /deep/ a {
  @apply text-motif-500;
  text-decoration: none;
}
.message /deep/ a::after {
  content: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGFyaWEtaGlkZGVuPSJ0cnVlIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgY2xhc3M9Imljb24gb3V0Ym91bmQiIGNvbG9yPSIjNDMzZWZmIj4KCTxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE4LjgsODUuMWg1NmwwLDBjMi4yLDAsNC0xLjgsNC00di0zMmgtOHYyOGgtNDh2LTQ4aDI4di04aC0zMmwwLDBjLTIuMiwwLTQsMS44LTQsNHY1NkMxNC44LDgzLjMsMTYuNiw4NS4xLDE4LjgsODUuMXoiPgoJPC9wYXRoPgoJPHBvbHlnb24gZmlsbD0iY3VycmVudENvbG9yIiBwb2ludHM9IjQ1LjcsNDguNyA1MS4zLDU0LjMgNzcuMiwyOC41IDc3LjIsMzcuMiA4NS4yLDM3LjIgODUuMiwxNC45IDYyLjgsMTQuOSA2Mi44LDIyLjkgNzEuNSwyMi45Ij4KCTwvcG9seWdvbj4KPC9zdmc+Cg==);
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-top: -10px;
}
.owner .message /deep/ a {
  color: white;
}
.owner .message /deep/ a::after {
  content: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGFyaWEtaGlkZGVuPSJ0cnVlIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgY2xhc3M9Imljb24gb3V0Ym91bmQiIGNvbG9yPSIjZmZmIj4KCTxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE4LjgsODUuMWg1NmwwLDBjMi4yLDAsNC0xLjgsNC00di0zMmgtOHYyOGgtNDh2LTQ4aDI4di04aC0zMmwwLDBjLTIuMiwwLTQsMS44LTQsNHY1NkMxNC44LDgzLjMsMTYuNiw4NS4xLDE4LjgsODUuMXoiPgoJPC9wYXRoPgoJPHBvbHlnb24gZmlsbD0iY3VycmVudENvbG9yIiBwb2ludHM9IjQ1LjcsNDguNyA1MS4zLDU0LjMgNzcuMiwyOC41IDc3LjIsMzcuMiA4NS4yLDM3LjIgODUuMiwxNC45IDYyLjgsMTQuOSA2Mi44LDIyLjkgNzEuNSwyMi45Ij4KCTwvcG9seWdvbj4KPC9zdmc+Cg==);
}
.message /deep/ a:hover {
  text-decoration: underline;
}
.message /deep/ a:active {
  text-decoration: underline;
}

/* .message /deep/ a, */
.message /deep/ p {
  color: #36333b;
  word-wrap: break-word;
  overflow-wrap: break-word !important;
}

.owner .message /deep/ p {
  color: white;
}

.message /deep/ strong {
  font-weight: bold;
  word-break: break-all;
}
.colorful .message /deep/ strong,
.owner .message /deep/ strong {
  color: white;
}

.colorful .message /deep/ blockquote,
.owner .message /deep/ blockquote {
  color: white;
}

.message /deep/ pre {
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 2rem;
  background-color: #fff;
}

/* .message.code-block /deep/ pre {
  max-height: 30rem;
  overflow: hidden;
} */
.message.code-block.expand /deep/ pre{
  max-height: inherit!important;
  overflow: auto!important;
}

.message /deep/ pre code {
  color: #000;
}

.owner .message /deep/ strong code,
.colorful .message /deep/ strong code {
  @apply text-white;
  background: rgba(255, 255, 255, 0.3);
}

.owner .message /deep/ table th {
  @apply text-white;
}
.owner .message /deep/ table tbody td {
  @apply text-gray-100;
}

.colorful .message /deep/ table th {
  @apply text-white;
}
.colorful .message /deep/ table tbody td {
  @apply text-gray-100;
}

.msg-text {
  @apply max-w-full ml-2;
}

.owner .msg-text {
  @apply mr-2;
}

.content-name {
  @apply mb-1 w-full truncate;
  color: #808490;
  font-size: 12px;
}

.owner .content-name {
  @apply text-right;
}

.message-icon {
  @apply absolute left-0 top-10;
  transform: translateX(-100%);
}

.owner .message-icon {
  @apply absolute left-full top-10;
  transform: rotateY(180deg) translateX(15%);
}

.note-svg {
  @apply absolute right-0 bottom-px w-6 cursor-pointer;
  transform: translateX(130%);
}

.note-svg.right {
  @apply absolute left-0;
  transform: translateX(-120%);
}
</style>
